import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFocusFrameXsS = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M2.1506e-06 1.83588e-07H24V3.6H2.1506e-06V1.83588e-07Z",
		fill: "#E7392D"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M3.6 0L3.6 24H0L2.1506e-06 1.83588e-07L3.6 0Z",
		fill: "#E7392D"
	})]
});
export default SvgFocusFrameXsS;
